import combi from './combi.png';
import other from './other.png';
import pt from './pt.png';
import rg_pg from './rg_pg.png';
import ss from './ss.png';
import ti from './ti.png';
import wg from './wg.png';
import yg from './yg.png';

const materialIcons = {
  combi,
  other,
  pt,
  rg_pg,
  ss,
  ti,
  wg,
  yg
};

export default materialIcons;
